const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function getQS(userId, rsaToken, channel) {
  return {
    userId: userId,
    tokenId: rsaToken,
    channel: channel
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    validateToken(rsaToken, metaData) {
      const url = getUrl('rsa-authentication');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const body = getQS(parsedMetaData.qs.userId, rsaToken, parsedMetaData.channel);

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },
  };
}

module.exports = apiFactory;
